import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

interface ShowMapMarkerProps {
  latitude: string | number;
  longitude: string | number;
}

const containerStyle = {
  width: "100%",
  height: "500px",
};

const ShowMapMarker: React.FC<ShowMapMarkerProps> = ({ latitude, longitude }) => {
  const [center, setCenter] = useState<{ lat: number; lng: number }>({ lat: 0, lng: 0 });
  const [markerPosition, setMarkerPosition] = useState<{ lat: number; lng: number }>({ lat: 0, lng: 0 });

  // Load the Google Maps JS API
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDoUJ8bw4eZDIblyzEgKWXYN9Y953yCqtA", // Add your key in .env
  });

  // Update center and marker whenever props change
useEffect(() => {
  const latNum = latitude ? parseFloat(latitude as string) : 51.5074; // default lat
  const lngNum = longitude ? parseFloat(longitude as string) : -0.1278; // default lng
  if (!isNaN(latNum) && !isNaN(lngNum)) {
    setCenter({ lat: latNum, lng: lngNum });
    setMarkerPosition({ lat: latNum, lng: lngNum });
  }
}, [latitude, longitude]);

  const mapOptions: google.maps.MapOptions = {
    center: center,
    zoomControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
  };

  if (!isLoaded) return <div>Loading map...</div>;

  return (
    <div className="map">
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15} options={mapOptions}>
        <Marker position={markerPosition} />
      </GoogleMap>
    </div>
  );
};

export default React.memo(ShowMapMarker);
